/**
 * Harness for the entire log view.
 */
import React, { PureComponent } from "react";
import LeftPanel from "./leftPanel/LeftPanel";
import RightPanel from "./rightPanel/RightPanel";

interface IProps {
	clientListVisible: boolean;
	fileMode?: boolean;
}

class LogView extends PureComponent<IProps> {
	render() {
		return (
			<div className="logger-wrapper">
				{this.props.clientListVisible ? <LeftPanel fileMode={this.props.fileMode} /> : <span />}
				<RightPanel />
			</div>
		);
	}
}

export default LogView;
